/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BaseHit Api
 * An API for accessing data for BaseHit.com
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BlockUserRequest,
  ConversationArchiveRequest,
  ConversationMarkReadRequest,
  ConversationReplyRequest,
  ConversationViewResponse,
  ErrorResult,
  GetMessagesConversationIdViewParams,
  GetMessagesViewParams,
  MessagePreferencesResponse,
  MessagesViewResponse,
  ProblemDetails,
  ReportMessageRequest,
  SendMessageResponse,
  StartConversationRequest,
  UnreadCountResponse,
  UpdateMessagePreferencesRequest
} from '../models';

import { fetcher } from '../../fetcher';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Inbox: the caller's conversations (archived filter) + total unread count.
 */
export const getMessagesView = (
    params?: GetMessagesViewParams,
 signal?: AbortSignal
) => {


      return fetcher<MessagesViewResponse>(
      {url: `/Messages/View`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetMessagesViewQueryKey = (params?: GetMessagesViewParams,) => {
    return [
    `/Messages/View`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMessagesViewQueryOptions = <TData = Awaited<ReturnType<typeof getMessagesView>>, TError = ProblemDetails>(params?: GetMessagesViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesView>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesViewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagesView>>> = ({ signal }) => getMessagesView(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagesView>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagesViewQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagesView>>>
export type GetMessagesViewQueryError = ProblemDetails


export function useGetMessagesView<TData = Awaited<ReturnType<typeof getMessagesView>>, TError = ProblemDetails>(
 params: undefined |  GetMessagesViewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesView>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesView>>,
          TError,
          Awaited<ReturnType<typeof getMessagesView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagesView<TData = Awaited<ReturnType<typeof getMessagesView>>, TError = ProblemDetails>(
 params?: GetMessagesViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesView>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesView>>,
          TError,
          Awaited<ReturnType<typeof getMessagesView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagesView<TData = Awaited<ReturnType<typeof getMessagesView>>, TError = ProblemDetails>(
 params?: GetMessagesViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesView>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Inbox: the caller's conversations (archived filter) + total unread count.
 */

export function useGetMessagesView<TData = Awaited<ReturnType<typeof getMessagesView>>, TError = ProblemDetails>(
 params?: GetMessagesViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesView>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagesViewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary One thread: a page of messages (cursor ?before={messageId} loads older), participants, canReply.
 */
export const getMessagesConversationIdView = (
    id: number,
    params?: GetMessagesConversationIdViewParams,
 signal?: AbortSignal
) => {


      return fetcher<ConversationViewResponse>(
      {url: `/Messages/Conversation/${id}/View`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetMessagesConversationIdViewQueryKey = (id: number,
    params?: GetMessagesConversationIdViewParams,) => {
    return [
    `/Messages/Conversation/${id}/View`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMessagesConversationIdViewQueryOptions = <TData = Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError = ProblemDetails>(id: number,
    params?: GetMessagesConversationIdViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesConversationIdViewQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagesConversationIdView>>> = ({ signal }) => getMessagesConversationIdView(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagesConversationIdViewQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagesConversationIdView>>>
export type GetMessagesConversationIdViewQueryError = ProblemDetails


export function useGetMessagesConversationIdView<TData = Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetMessagesConversationIdViewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesConversationIdView>>,
          TError,
          Awaited<ReturnType<typeof getMessagesConversationIdView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagesConversationIdView<TData = Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError = ProblemDetails>(
 id: number,
    params?: GetMessagesConversationIdViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesConversationIdView>>,
          TError,
          Awaited<ReturnType<typeof getMessagesConversationIdView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagesConversationIdView<TData = Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError = ProblemDetails>(
 id: number,
    params?: GetMessagesConversationIdViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One thread: a page of messages (cursor ?before={messageId} loads older), participants, canReply.
 */

export function useGetMessagesConversationIdView<TData = Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError = ProblemDetails>(
 id: number,
    params?: GetMessagesConversationIdViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesConversationIdView>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagesConversationIdViewQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Unread conversation count — the header envelope badge poll.
 */
export const getMessagesUnreadCount = (

 signal?: AbortSignal
) => {


      return fetcher<UnreadCountResponse>(
      {url: `/Messages/UnreadCount`, method: 'GET', signal
    },
      );
    }




export const getGetMessagesUnreadCountQueryKey = () => {
    return [
    `/Messages/UnreadCount`
    ] as const;
    }


export const getGetMessagesUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagesUnreadCount>>> = ({ signal }) => getMessagesUnreadCount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagesUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagesUnreadCount>>>
export type GetMessagesUnreadCountQueryError = ProblemDetails


export function useGetMessagesUnreadCount<TData = Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getMessagesUnreadCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagesUnreadCount<TData = Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getMessagesUnreadCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagesUnreadCount<TData = Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Unread conversation count — the header envelope badge poll.
 */

export function useGetMessagesUnreadCount<TData = Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagesUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Find-or-create the DM with the recipient and append the message.
 */
export const postMessagesConversations = (
    startConversationRequest?: StartConversationRequest,
 signal?: AbortSignal
) => {


      return fetcher<SendMessageResponse>(
      {url: `/Messages/Conversations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startConversationRequest, signal
    },
      );
    }




export const getPostMessagesConversationsMutationKey = () => ['postMessagesConversations'] as const;

export const getPostMessagesConversationsMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesConversations>>, TError,PostMessagesConversationsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postMessagesConversations>>, TError,PostMessagesConversationsMutationVariables, TContext> => {

const mutationKey = getPostMessagesConversationsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMessagesConversations>>, PostMessagesConversationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postMessagesConversations(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMessagesConversationsMutationResult = NonNullable<Awaited<ReturnType<typeof postMessagesConversations>>>
    export type PostMessagesConversationsMutationBody = StartConversationRequest | undefined
    export type PostMessagesConversationsMutationError = ErrorResult | ProblemDetails
    export type PostMessagesConversationsMutationVariables = {data?: StartConversationRequest}

    /**
 * @summary Find-or-create the DM with the recipient and append the message.
 */
export const usePostMessagesConversations = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesConversations>>, TError,PostMessagesConversationsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMessagesConversations>>,
        TError,
        PostMessagesConversationsMutationVariables,
        TContext
      > => {
      return useMutation(getPostMessagesConversationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Reply into an existing conversation.
 */
export const postMessagesConversationId = (
    id: number,
    conversationReplyRequest?: ConversationReplyRequest,
 signal?: AbortSignal
) => {


      return fetcher<SendMessageResponse>(
      {url: `/Messages/Conversation/${id}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: conversationReplyRequest, signal
    },
      );
    }




export const getPostMessagesConversationIdMutationKey = () => ['postMessagesConversationId'] as const;

export const getPostMessagesConversationIdMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesConversationId>>, TError,PostMessagesConversationIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postMessagesConversationId>>, TError,PostMessagesConversationIdMutationVariables, TContext> => {

const mutationKey = getPostMessagesConversationIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMessagesConversationId>>, PostMessagesConversationIdMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  postMessagesConversationId(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMessagesConversationIdMutationResult = NonNullable<Awaited<ReturnType<typeof postMessagesConversationId>>>
    export type PostMessagesConversationIdMutationBody = ConversationReplyRequest | undefined
    export type PostMessagesConversationIdMutationError = ErrorResult | ProblemDetails
    export type PostMessagesConversationIdMutationVariables = {id: number;data?: ConversationReplyRequest}

    /**
 * @summary Reply into an existing conversation.
 */
export const usePostMessagesConversationId = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesConversationId>>, TError,PostMessagesConversationIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMessagesConversationId>>,
        TError,
        PostMessagesConversationIdMutationVariables,
        TContext
      > => {
      return useMutation(getPostMessagesConversationIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Advance the caller's read pointer in a conversation.
 */
export const putMessagesConversationIdRead = (
    id: number,
    conversationMarkReadRequest?: ConversationMarkReadRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Messages/Conversation/${id}/Read`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: conversationMarkReadRequest, signal
    },
      );
    }




export const getPutMessagesConversationIdReadMutationKey = () => ['putMessagesConversationIdRead'] as const;

export const getPutMessagesConversationIdReadMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMessagesConversationIdRead>>, TError,PutMessagesConversationIdReadMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMessagesConversationIdRead>>, TError,PutMessagesConversationIdReadMutationVariables, TContext> => {

const mutationKey = getPutMessagesConversationIdReadMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMessagesConversationIdRead>>, PutMessagesConversationIdReadMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putMessagesConversationIdRead(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutMessagesConversationIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof putMessagesConversationIdRead>>>
    export type PutMessagesConversationIdReadMutationBody = ConversationMarkReadRequest | undefined
    export type PutMessagesConversationIdReadMutationError = ProblemDetails
    export type PutMessagesConversationIdReadMutationVariables = {id: number;data?: ConversationMarkReadRequest}

    /**
 * @summary Advance the caller's read pointer in a conversation.
 */
export const usePutMessagesConversationIdRead = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMessagesConversationIdRead>>, TError,PutMessagesConversationIdReadMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMessagesConversationIdRead>>,
        TError,
        PutMessagesConversationIdReadMutationVariables,
        TContext
      > => {
      return useMutation(getPutMessagesConversationIdReadMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive / unarchive a conversation for the caller only (per-user soft hide).
 */
export const putMessagesConversationIdArchive = (
    id: number,
    conversationArchiveRequest?: ConversationArchiveRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Messages/Conversation/${id}/Archive`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: conversationArchiveRequest, signal
    },
      );
    }




export const getPutMessagesConversationIdArchiveMutationKey = () => ['putMessagesConversationIdArchive'] as const;

export const getPutMessagesConversationIdArchiveMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMessagesConversationIdArchive>>, TError,PutMessagesConversationIdArchiveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMessagesConversationIdArchive>>, TError,PutMessagesConversationIdArchiveMutationVariables, TContext> => {

const mutationKey = getPutMessagesConversationIdArchiveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMessagesConversationIdArchive>>, PutMessagesConversationIdArchiveMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putMessagesConversationIdArchive(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutMessagesConversationIdArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof putMessagesConversationIdArchive>>>
    export type PutMessagesConversationIdArchiveMutationBody = ConversationArchiveRequest | undefined
    export type PutMessagesConversationIdArchiveMutationError = ProblemDetails
    export type PutMessagesConversationIdArchiveMutationVariables = {id: number;data?: ConversationArchiveRequest}

    /**
 * @summary Archive / unarchive a conversation for the caller only (per-user soft hide).
 */
export const usePutMessagesConversationIdArchive = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMessagesConversationIdArchive>>, TError,PutMessagesConversationIdArchiveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMessagesConversationIdArchive>>,
        TError,
        PutMessagesConversationIdArchiveMutationVariables,
        TContext
      > => {
      return useMutation(getPutMessagesConversationIdArchiveMutationOptions(options), queryClient);
    }
    /**
 * @summary Block another user from messaging the caller.
 */
export const postMessagesBlocks = (
    blockUserRequest?: BlockUserRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Messages/Blocks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: blockUserRequest, signal
    },
      );
    }




export const getPostMessagesBlocksMutationKey = () => ['postMessagesBlocks'] as const;

export const getPostMessagesBlocksMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesBlocks>>, TError,PostMessagesBlocksMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postMessagesBlocks>>, TError,PostMessagesBlocksMutationVariables, TContext> => {

const mutationKey = getPostMessagesBlocksMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMessagesBlocks>>, PostMessagesBlocksMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postMessagesBlocks(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMessagesBlocksMutationResult = NonNullable<Awaited<ReturnType<typeof postMessagesBlocks>>>
    export type PostMessagesBlocksMutationBody = BlockUserRequest | undefined
    export type PostMessagesBlocksMutationError = ErrorResult | ProblemDetails
    export type PostMessagesBlocksMutationVariables = {data?: BlockUserRequest}

    /**
 * @summary Block another user from messaging the caller.
 */
export const usePostMessagesBlocks = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesBlocks>>, TError,PostMessagesBlocksMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMessagesBlocks>>,
        TError,
        PostMessagesBlocksMutationVariables,
        TContext
      > => {
      return useMutation(getPostMessagesBlocksMutationOptions(options), queryClient);
    }
    /**
 * @summary Unblock a user (idempotent).
 */
export const deleteMessagesBlocksUserId = (
    userId: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Messages/Blocks/${userId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteMessagesBlocksUserIdMutationKey = () => ['deleteMessagesBlocksUserId'] as const;

export const getDeleteMessagesBlocksUserIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMessagesBlocksUserId>>, TError,DeleteMessagesBlocksUserIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteMessagesBlocksUserId>>, TError,DeleteMessagesBlocksUserIdMutationVariables, TContext> => {

const mutationKey = getDeleteMessagesBlocksUserIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMessagesBlocksUserId>>, DeleteMessagesBlocksUserIdMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  deleteMessagesBlocksUserId(userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMessagesBlocksUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMessagesBlocksUserId>>>

    export type DeleteMessagesBlocksUserIdMutationError = ProblemDetails
    export type DeleteMessagesBlocksUserIdMutationVariables = {userId: number}

    /**
 * @summary Unblock a user (idempotent).
 */
export const useDeleteMessagesBlocksUserId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMessagesBlocksUserId>>, TError,DeleteMessagesBlocksUserIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMessagesBlocksUserId>>,
        TError,
        DeleteMessagesBlocksUserIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteMessagesBlocksUserIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Flag a message for review.
 */
export const postMessagesReports = (
    reportMessageRequest?: ReportMessageRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Messages/Reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportMessageRequest, signal
    },
      );
    }




export const getPostMessagesReportsMutationKey = () => ['postMessagesReports'] as const;

export const getPostMessagesReportsMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesReports>>, TError,PostMessagesReportsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postMessagesReports>>, TError,PostMessagesReportsMutationVariables, TContext> => {

const mutationKey = getPostMessagesReportsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMessagesReports>>, PostMessagesReportsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postMessagesReports(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMessagesReportsMutationResult = NonNullable<Awaited<ReturnType<typeof postMessagesReports>>>
    export type PostMessagesReportsMutationBody = ReportMessageRequest | undefined
    export type PostMessagesReportsMutationError = ErrorResult | ProblemDetails
    export type PostMessagesReportsMutationVariables = {data?: ReportMessageRequest}

    /**
 * @summary Flag a message for review.
 */
export const usePostMessagesReports = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMessagesReports>>, TError,PostMessagesReportsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMessagesReports>>,
        TError,
        PostMessagesReportsMutationVariables,
        TContext
      > => {
      return useMutation(getPostMessagesReportsMutationOptions(options), queryClient);
    }
    /**
 * @summary The caller's messaging preferences.
 */
export const getMessagesPreferences = (

 signal?: AbortSignal
) => {


      return fetcher<MessagePreferencesResponse>(
      {url: `/Messages/Preferences`, method: 'GET', signal
    },
      );
    }




export const getGetMessagesPreferencesQueryKey = () => {
    return [
    `/Messages/Preferences`
    ] as const;
    }


export const getGetMessagesPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getMessagesPreferences>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagesPreferences>>> = ({ signal }) => getMessagesPreferences(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagesPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagesPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagesPreferences>>>
export type GetMessagesPreferencesQueryError = ProblemDetails


export function useGetMessagesPreferences<TData = Awaited<ReturnType<typeof getMessagesPreferences>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesPreferences>>,
          TError,
          Awaited<ReturnType<typeof getMessagesPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagesPreferences<TData = Awaited<ReturnType<typeof getMessagesPreferences>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagesPreferences>>,
          TError,
          Awaited<ReturnType<typeof getMessagesPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagesPreferences<TData = Awaited<ReturnType<typeof getMessagesPreferences>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The caller's messaging preferences.
 */

export function useGetMessagesPreferences<TData = Awaited<ReturnType<typeof getMessagesPreferences>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagesPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagesPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update the caller's messaging preferences.
 */
export const putMessagesPreferences = (
    updateMessagePreferencesRequest?: UpdateMessagePreferencesRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Messages/Preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMessagePreferencesRequest, signal
    },
      );
    }




export const getPutMessagesPreferencesMutationKey = () => ['putMessagesPreferences'] as const;

export const getPutMessagesPreferencesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMessagesPreferences>>, TError,PutMessagesPreferencesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMessagesPreferences>>, TError,PutMessagesPreferencesMutationVariables, TContext> => {

const mutationKey = getPutMessagesPreferencesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMessagesPreferences>>, PutMessagesPreferencesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putMessagesPreferences(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutMessagesPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof putMessagesPreferences>>>
    export type PutMessagesPreferencesMutationBody = UpdateMessagePreferencesRequest | undefined
    export type PutMessagesPreferencesMutationError = ProblemDetails
    export type PutMessagesPreferencesMutationVariables = {data?: UpdateMessagePreferencesRequest}

    /**
 * @summary Update the caller's messaging preferences.
 */
export const usePutMessagesPreferences = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMessagesPreferences>>, TError,PutMessagesPreferencesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMessagesPreferences>>,
        TError,
        PutMessagesPreferencesMutationVariables,
        TContext
      > => {
      return useMutation(getPutMessagesPreferencesMutationOptions(options), queryClient);
    }
